import React from 'react';
import { Container } from 'vendors/semantic-ui';

import { BackToTop, Footer } from 'modules/shared/components';
import { Header } from '../../components';

import { Props } from './personal-space-layout-type';

import styles from './personal-space-layout.module.css';

export const PersonalSpaceLayout: React.FC<Props> = ({ children, headerChildren, ...rest }: Props) => {
    return (
        <React.Fragment>
            <BackToTop />
            <Header {...rest}>{headerChildren}</Header>
            <Container className={`${styles.mainContainer}`}>{children}</Container>
            <Footer />
        </React.Fragment>
    );
};
